import { ApiResponse } from './../../models/ApiResponse';
import { HttpParams } from '@angular/common/http';
import { AccountReservedLocation } from './../../models/AccountReservedLocation';
import { ReservedLocation } from './../../models/ReservedLocation';
import { API_URL, DATE_FORMAT } from './../../app.constant';
import { Account } from './../../models/account';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BasicAuthenticationService } from 'src/app/auth/basic-authentication.service';

const COM_CreateAccount: string = "COM_CreateAccount";
const COM_GetAccount: string = "COM_GetAccount";
const COM_UpdateAccount: string = "COM_UpdateAccount";
const COM_UpdatePassword: string = "COM_UpdatePassword";

const COM_DeleteAccount: string = "COM_DeleteAccount";
const COM_ResetPassword: string = "COM_ResetPassword";

const COM_GETSUBACCOUNTBYMAINACCOUNTID = "COM_GetSubAccountByMainAccountId";

@Injectable({
  providedIn: 'root'
})
export class AccountDataService {

  constructor(private httpClient: HttpClient,private datePipe: DatePipe, 
    private basicAuthenticationService: BasicAuthenticationService) { }

  createAccount(account: Account, locationArray: ReservedLocation[]){

    let accountReservedLocation: AccountReservedLocation = new AccountReservedLocation(account, locationArray);

    console.log(JSON.stringify(accountReservedLocation));

    return this.httpClient.post<any>(`${API_URL}/${COM_CreateAccount}`, {accountReservedLocation});

  }

  getAccount(accountId: string){

    let params = new HttpParams().set('accountId', accountId);

    return this.httpClient.get<ApiResponse<Account>>(`${API_URL}/${COM_GetAccount}`,{params});
  }

  updateAccount(account: Account){

    console.log("updateAccount: " + JSON.stringify(account));

    account.actionBy = this.basicAuthenticationService.getAuthenticatedUser();

    return this.httpClient.post<any>(`${API_URL}/${COM_UpdateAccount}`, account);
  }


  updatePassword(account: Account){

    console.log("updateAccount: " + JSON.stringify(account));

    return this.httpClient.post<any>(`${API_URL}/${COM_UpdatePassword}`, account);
  }

  deleteAccount(accountId: string,  lastUpdateDate: Date){

    console.log("Before delete method..");

    let params = new HttpParams()
    .set('accountId', accountId)
    .set('lastUpdateDate', this.datePipe.transform(lastUpdateDate,DATE_FORMAT));


    return this.httpClient.delete<any>(`${API_URL}/${COM_DeleteAccount}`,{params});
  }


  resetPassword(accountId: string, phoneNo: string){

    var account = new Account(
       accountId,
       '',
       '',
       '',
       '',
       '',
       phoneNo,
       new Date(),
       '',
       '',
       0,
       '',
       '',
       0,
       0,
       0,
       new Date(),
       '',
       new Date(),
       ''
    );

    return this.httpClient.post<any>(`${API_URL}/${COM_ResetPassword}`, account);
  }


  getSubAccountByMainAccountId(mainAccountId){

    let params = new HttpParams().set('mainAccountId', mainAccountId);

    return this.httpClient.get<Account[]>(`${API_URL}/${COM_GETSUBACCOUNTBYMAINACCOUNTID}`, { params });
  }


}
